<main class="detail" id="billing">
    <header>
        <header-component></header-component>
        <div class="nav">
            <h1>{{ app.checkedin ? _('online_payment') : _('prepayment')}}</h1>
            <span class="icon back" @click="app.setPage('Terminal')">
                chevron_left
            </span>
        </div>
    </header>
    <div v-show="breakdown.length">
        <h2>{{_("please_check_the_following_information")}}</h2>
        <div class="top_label">
            <div class="label-content">
                <h3>{{_("claim_amount")}}</h3>
                <p>{{ total() | price}}</p>
            </div>
        </div>
        <table>
            <thead>
                <tr>
                    <th>{{_("billing_breakdown")}}</th>
                    <th>{{_("merchandise_price")}}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="bill in breakdown">
                    <td>{{ bill.item_name }}</td>
                    <td>{{ bill.amount | price }}</td>
                </tr>
            </tbody>
        </table>
        <div class="controls">
            <button @click="app.setPage('Terminal')" class="gray">
                {{_('go_back')}}
            </button>
            <button @click="app.setPage('Billing')">{{_('go_next')}}</button>
        </div>
    </div>
</main>
